import React, { useContext, useEffect, useState } from "react";
import Services from "../../network/Services";
import { formatNumberToUS, formatPhoneNumber } from "../../control/Constant";
import { Modal } from "antd";
import { UserContext } from "../../App";


const AttorneyTable = () => {
    const tableHeader = ['Name','Total Revenue','Base + Bonus','Revenue Share','Resposibility','Origination','Clients'];
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    const [attorneyData,setAttorneydata] = useState([])
    const [showModal,setShowmodal] = useState(false)
    const [attorneyItem,setAttorneyitem] = useState({})
    const [pageNumber,setPagenumber] = useState(1)
    const { setLoader } = useContext(UserContext)
    const [legalStafflist,setLegalstafflist] = useState([])
    const [selecMonthyear,setSelectmonthyear] = useState({month:0,year:new Date().getFullYear()})
    const [customDate,setCustomdate] = useState({startDate:'',endDate:new Date()})
    const [selectedStaff,setSelectedstaff] = useState('')

    useEffect(()=>{
        getUserLegalStafffunc(2)
    },[])

    useEffect(()=>{
        if(pageNumber == 1) return;
        getAttorneyRecords(pageNumber)
    },[pageNumber])

    useEffect(()=>{
        // console.log(customDate,"customDateselectDate",selectDate)
        setPagenumber(1)
        getAttorneyRecords(1,selectedStaff)
    },[customDate.startDate,customDate.endDate,selectedStaff])

    // useEffect(()=>{
    //     if(attorneyData?.length == 0){
    //         setLoader(true)
    //     }else{
    //         setLoader(false)
    //     }
    // },[attorneyData?.length])



    const getAttorneyRecords = (pageNumber,userId) => {
        let today = new Date(customDate.startDate)
        let endDate = new Date(customDate.endDate)

        // console.log(customDate,"endDate","customDatecustomDate",today,endDate)
        setLoader(true)
        let jsonObj = {
        "subtenantId": 2,
        "startDate": today || '',
        "endDate": endDate || '',
        "attorneyUserId": userId || '',
        "isActive": true,
        "pageNumber": pageNumber,
        "rowsOfPage": 12
        }
        // console.log(jsonObj,"customDatecustomDate2")
        setLoader(true)
        const getAttorneyRecords = Services.getAttorneyRecords(jsonObj)
        getAttorneyRecords.then((res)=>{
            // console.log(res,"getAttorneyRecordsresponse",pageNumber)
            setLoader(false)
            if(pageNumber > 1){
            setAttorneydata((prev) => [...prev,...res.data.data])
            }else{
                setAttorneydata(res.data.data)
            }
        }).catch((err)=>{
            setLoader(false)
            // console.log(err,'error')
        }).finally(()=>{
            setLoader(false)
        })
    }

    const showModalfunc = (item) => {
        setShowmodal(true)
        setAttorneyitem(item)
    }

    const scrollCallBack = (e) => {
        const node = e.target;

        if (node) {
        const { scrollTop, scrollHeight, clientHeight } = node;
        const scrollScreen = scrollTop + clientHeight;

        if (Math.ceil(scrollScreen) >= scrollHeight) {
            setPagenumber(prev => prev+1)
        }
        }
    }



    const getUserLegalStafffunc = (subtenantId) => {
        let getUserLegalStaff = Services.getUserListByRoleIdAcadmy(subtenantId,true,'LEGAL')
        getUserLegalStaff.then((res)=>{
            // console.log(res,'responsegetUserLegalStafffunc')
            setLegalstafflist(res.data.data)
        }).catch((err)=>{
            console.log(err,'error')
        })
    }


    const onSelectSearch = (e) => {
        // console.log(e.target.value,"attornryId")
        let userId = e.target.value
        // getAttorneyRecords(1,userId)
        setSelectedstaff(userId)
    }

    const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = '1980'; year <= currentYear; year++) {
    years.unshift(year);
    }

    return years;
    }

    function getStartEndDate(year, monthStr) {

    if (monthStr !== null) {
        const monthIndex = monthNames.indexOf(monthStr);

        if (monthIndex === -1) {
        throw new Error('Invalid month name. Please provide a valid month name.');
        }

        const startDate = new Date(year, monthIndex, 1);

        const endDate = new Date(year, monthIndex + 1, 0);

        return {
        startDate: startDate.toLocaleDateString('en-US'),
        endDate: endDate.toLocaleDateString('en-US'),
        };
    }

    const startDate = new Date(year, 0, 1);

    const endDate = new Date(year, 11, 31);

    return {
        startDate: startDate.toLocaleDateString('en-US'),
        endDate: endDate.toLocaleDateString('en-US'),
    };
    }


    const applyMonthfilter = () => {
        let {startDate,endDate} = getStartEndDate(selecMonthyear.year,selecMonthyear.month == 'All'?null:selecMonthyear.month)
        setCustomdate({startDate:startDate,endDate:endDate})
        // console.log(selecMonthyear,"selecMonthyear",startDate,endDate)
        // getAttorneyRecords(1)

    }

    const calPercentage = (amount,percentage) => {
        let calculationPercentage = (amount * percentage) / 100
        return calculationPercentage;
    }

    const calculateCompatation = (data,compItem) => {
        // console.log(compItem,"compItemdata",data)

        let compModelTypeId = compItem?.compModelTypeId
        if(compItem?.compModelTypeId == 1){

            console.log('compModelTypeId: 1')
            let salaryTotal = data.reponsibleAmount+data.originatingAmount;
            let calculateAmount = salaryTotal - compItem.revenueThreshold
            let bonusAmount = calPercentage(calculateAmount,compItem.bonusPer)
            // console.log(bonusAmount,"bonusAmount",compItem,"calculateAmount",calculateAmount)
            bonusAmount = bonusAmount > 0 ? bonusAmount : '0.00'

            return {compModelTypeId,bonusAmount};
        }
        else{
            let responsibleAmount = calPercentage(compItem?.responsiblePer,data.reponsibleAmount)
            let originatingAmount = calPercentage(compItem?.originatingPer,data.originatingAmount)

            // console.log('compModelTypeId: 2',responsibleAmount,"responsibleAmount",originatingAmount,compItem)
            return {compModelTypeId,responsibleAmount,originatingAmount}
        }
    }

    // console.log(attorneyData,"attorneyData",attorneyItem,"attorneyItem")
    return <>
    <div className="d-flex justify-content-between m-2 mb-3">
    <select className="p-2 border border-2 rounded-2" onChange={(e)=>{onSelectSearch(e)}}>
        <option disabled>Search Attorney by name</option>
        <option value="">All</option>
        {legalStafflist?.map((e)=>(
            <option value={e.userId}>{e.fullName}</option>
        ))}
    </select>
    <div className="d-flex gap-2 align-items-center">
        <select className="p-2 border border-2 rounded-2" onChange={(e)=>setSelectmonthyear(prev=>({...prev,year:e.target.value}))}>
            <option disabled>Select Year</option>
            {generateYears().map((e)=>(<option>{e}</option>))}
        </select>
        <select className="p-2 border border-2 rounded-2" onChange={(e)=>setSelectmonthyear(prev=>({...prev,month:e.target.value}))}>
            <option disabled>Select Month</option>
            <option>All</option>
            {monthNames.map((e)=>(<option>{e}</option>))}
        </select>
        <button className="primary-btn p-1" onClick={()=>applyMonthfilter()}>Apply</button>
    </div>
    </div>
    <div className="table-wrapper w-100 h-100" style={{ width: "100%", borderSpacing: 0, maxHeight: "calc(100vh - 160px)",overflow:'auto'}} onScroll={scrollCallBack}>
    <table className="table border" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0}} >
        <thead>
        <tr>
            {tableHeader.map((e, index) => {
            if (e === 'Base + Bonus') {
                return (
                <th key={index} colSpan={1} className="text-center align-bottom p-2 fw-bold shadow-sm">
                    Base + Bonus
                </th>
                );
            } else if (e === 'Revenue Share') {
                return (
                <th key={index} colSpan={2} className="text-center align-bottom p-2 fw-bold shadow-sm">
                    Revenue Share
                </th>
                );
            } else {
                return (
                <th key={index} rowSpan={2} className="text-center align-middle p-2 fw-bold shadow-sm">
                    {e}
                </th>
                );
            }
            })}
        </tr>
        <tr>
            {tableHeader.map((e, index) => {
            if (e === 'Base + Bonus') {
                return (
                <th key={`${index}-sub`} className="text-center fw-normal p-2 shadow-sm">
                    Bonus
                </th>
                );
            } else if (e === 'Revenue Share') {
                return (
                <>
                    <th key={`${index}-sub1`} className="text-center fw-normal p-2 shadow-sm" style={{ borderRight: '1px solid #dee2e6' }}>
                    Responsible Bonus
                    </th>
                    <th key={`${index}-sub2`} className="text-center fw-normal p-2 shadow-sm">
                    Originating Bonus
                    </th>
                </>
                );
            }
            return null;
            })}
        </tr>
        </thead>
        <tbody>{attorneyData.map((e)=>{
        let compensationData = e?.compensationDetails.filter((ele) => {
        return new Date(ele.effectiveDate) <= new Date(customDate.endDate)
        });
        let compensationItem = compensationData?.filter((ele)=>{
        //    return new Date(ele.effectiveDate).getMonth()+1 == new Date(customDate?.endDate).getMonth()+1
        return ele
        })
        let calculatedBonus = compensationItem?.map((comp)=> calculateCompatation(e,comp))
        const totalBonus = calculatedBonus?.reduce((sum, item) => {return item.compModelTypeId === 1 ? sum + Number(item.bonusAmount) : sum;}, 0);
        const totalResponsible = calculatedBonus?.reduce((sum, item) => {return item.compModelTypeId === 2 ? sum + item.responsibleAmount : sum;}, 0);
        const totalOriniging = calculatedBonus?.reduce((sum, item) => {return item.compModelTypeId === 2 ? sum + item.originatingAmount : sum;}, 0);

        return <tr>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{e.attorneyName}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(e.reponsibleAmount+e.originatingAmount)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(totalBonus)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(totalResponsible)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(totalOriniging)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(e.reponsibleAmount)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{formatNumberToUS(e.originatingAmount)}</td>
        <td className="p-2" style={{borderRight: "1px solid #dee2e6"}}>{e.responsible.length + e.originating.length}</td>
        </tr>})}
        </tbody>
    </table>
    </div>
    <Modal
        title={`Attorney Details: ${attorneyItem.attorneyName}`}
        visible={showModal}
        onCancel={() => {
          setShowmodal(false);
          setAttorneyitem({});
        }}
        enforceFocus={false}
        footer={null}
        destroyOnClose={true}
        style={{ zIndex: 9999}}
        closeIcon={<div className='text-light'><img width="14px" src='/icons/crossIcon.svg' /></div>}
        >
        <div>
            <div className="d-flex flex-wrap">
                <div className="cardItem">Total Revenue<p>$0</p></div>
                <div className="cardItem">Origination Revenue<p>$0</p></div>
                <div className="cardItem">Responsibility Revenue<p>$0</p></div>
                <div className="cardItem">Active Clients<p>{attorneyItem?.responsible?.length}</p></div>
                <div className="cardItem">Completed Agreements<p>0</p></div>
            </div>
        </div>
      </Modal>
    </>
}
export default AttorneyTable;